// @ts-nocheck
import {Column} from 'react-table'
import {ReservationCustomHeader} from './ReservationCustomHeader'
import {Reservation} from '../../core/_models'
import { ReservationInfoCell } from '../../../../../../_dashboard/partials/components/commonColumns/ReservationCell'
import { ReservationActionsCell } from './ReservationActionsCell'
import { useIntl } from 'react-intl'; 

const reservationsColumns: ReadonlyArray<Column<Reservation>> = [
  // {
  //   Header: (props) => (
  //     <ReservationCustomHeader
  //       tableProps={props}
  //       title={useIntl().formatMessage({ id: 'COLUMNS.ID' })}
  //       className='min-w-125px'
  //     />
  //   ),
  //   accessor: 'hotel.hotel_id',
  // },
  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.HOTEL_NAME' })}
        className='min-w-125px'
      />
    ),
    id: 'hotel.name',
    Cell: ({...props}) => <ReservationInfoCell reservation={props.data[props.row.index]} />,
  },
  

 

  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.PAYMENT_METHOD' })}
        className='min-w-125px'
      />
    ),
    accessor: 'paymentMethod',
    Cell: ({ value }: { value: any }) => (
      <span>{value?.translations?.[0]?.name || value?.description || 'N/A'}</span> 
    ),
  },

  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.CLIENT_INFO' })}
        className='min-w-200px'
      />
    ),
    accessor: 'name',
    Cell: ({ row }: { row: any }) => {
      const reservation = row.original;
      return (
        <div className='d-flex flex-column'>
          <span className='fw-bold'>{reservation.civility} {reservation.name} {reservation.surname}</span>
          <span className='text-muted fs-7'>📧 {reservation.email}</span>
          <span className='text-muted fs-7'>📞 {reservation.phone}</span>
        </div>
      );
    },
  },

  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.VOUCHER_NUMBER' })}
        className='min-w-125px'
      />
    ),
    accessor: 'voucherNum',
    Cell: ({ value }: { value: string }) => (
      <span className='badge badge-light-info'>{value || 'N/A'}</span>
    ),
  },
  
  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.STATUS' })}
        className='min-w-125px'
      />
    ),
    accessor: 'status',
    Cell: ({ value }: { value: { code: number; name: string; color: string } | null }) => (
      <span
        style={{
          backgroundColor: value?.color || '#6c757d',
          color: '#fff', 
          padding: '4px 8px',
          borderRadius: '4px',
          fontSize: '12px',
          fontWeight: 'bold',
        }}
      >
        {value?.name || 'En attente'}
      </span>
    ),
    },

  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.TOTAL_PRICE' })}
        className='min-w-125px'
      />
    ),
    accessor: 'totalPrice',
  },

  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.CHECK_IN_DATE' })}
        className='min-w-125px'
      />
    ),
    accessor: 'checkInDate',
    Cell: ({ value }: { value: string }) => (
      <span className="text-muted">{new Date(value)?.toLocaleString()}</span>
    ),

  },

  {
    Header: (props) => (
      <ReservationCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.CREATED_AT' })}
        className='min-w-125px'
      />
    ),
    accessor: 'createdAt',
    Cell: ({ value }: { value: string }) => (
      <span className="text-muted">{new Date(value)?.toLocaleString()}</span>
    ),

  },


  {
   
    id: 'actions',
    Cell: ({...props}) => <ReservationActionsCell id={props.data[props.row.index]._id} />,
  },

]

export {reservationsColumns}
